<template>
  <div
    class="bg-white shadow-md rounded-md p-3 flex flex-col justify-between relative overflow-hidden h-full"
  >
    <div class="flex gap-2 items-center z-10 relative">
      <div
        class="w-7 min-w-7 h-7 rounded-md flex justify-center items-center bg-orange-400"
      >
        <img
          src="../../../assets/icon/fuel-station.png"
          alt="icon"
          loading="eager"
          class="w-4 h-auto"
        />
      </div>
      <h5 class="font-semibold text-[10px] text-gray-800 text-wrap">
        YTD Fuel Ratio Liter / Ton
      </h5>
    </div>
    <h3 class="text-3xl font-bold text-gray-800 z-10 relative">
      {{ formatFloat(data?.fuel_ratio) }}
      <span class="font-normal text-2xl"> Lt/ Ton </span>
    </h3>
    <div class="flex gap-2 items-center relative z-10">
      <div
        class="flex justify-center items-center rounded-md h-7"
        :class="{
          'bg-green-100 pr-2': data?.percentage_change > 0,
          'bg-red-100 pr-2': data?.percentage_change < 0,
          'bg-gray-200 min-w-14': data?.percentage_change == 0,
        }"
      >
        <img
          v-if="data?.percentage_change > 0"
          src="../../../assets/icon/mdi-menu-up.svg"
          alt="icon"
        />
        <img
          v-if="data?.percentage_change < 0"
          src="../../../assets/icon/mdi-menu-down.svg"
          alt="icon"
        />
        <img
          v-if="data?.percentage_change == 0"
          src="../../../assets/icon/mdi-equal.svg"
          alt="icon"
        />
        <h6
          class="font-semibold text-xs"
          v-if="data?.percentage_change && data?.percentage_change !== 0"
          :class="[
            data?.percentage_change >= 0 ? 'text-green-600' : 'text-red-600',
          ]"
        >
          {{ data?.percentage_change }}%
        </h6>
      </div>
      <h6 class="text-gray-400 font-normal text-[10px]">
        from<br />
        last month
      </h6>
    </div>
    <div
      class="w-36 h-36 rounded-full bg-orange-100 -right-14 top-20 -z-0 opacity-50 absolute"
    ></div>
    <div
      class="w-16 h-16 rounded-full bg-orange-100 -right-7 top-12 absolute -z-0 opacity-50"
    ></div>
  </div>
</template>

<script>
import { formatFloat } from "@/utilities/helpers";

export default {
  name: "CardFuelComponent",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatFloat,
  },
};
</script>
